'use client';
import { useEffect } from "react";
import { extendTheme} from "@chakra-ui/react";

const breakpoints = {
  sm: "30em", // 480px
  md: "48em", // 768px
  lg: "70em", // 1280px
  xl: "90em", // 1920px
  xxl:'120em'
};

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  breakpoints:breakpoints
});
export function ClearColorMode() {
  useEffect(() => {
    
    localStorage.removeItem("chakra-ui-color-mode");
  }, []);
  return null;
}
export default theme;
